/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as IdentityDefs from "./defs.defs.js";

const $nsid = "com.atproto.identity.refreshIdentity";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"identifier":/*#__PURE__*/ l.string({"format":"at-identifier"})});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.payload("application/json", /*#__PURE__*/ l.ref<IdentityDefs.IdentityInfo>((() => IdentityDefs.identityInfo) as any));

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Request that the server re-resolve an identity (DID and handle). The server may ignore this request, or require authentication, depending on the role, implementation, and policy of the server. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["HandleNotFound","DidNotFound","DidDeactivated"]);

export { main };

export const $lxm = $nsid;
